import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { CollaborateurService } from '@shared/services/cabinet/collaborateur.service';
import { DossierService } from '@shared/services/cabinet/dossier.service';
import { PreferenceService } from '@shared/services/cabinet/preference.service';

const excludedRoutes: { method: string; urlPattern: RegExp }[] = [
  { method: 'GET', urlPattern: /ForUser/ },
];

export const userClientInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const shouldExclude = excludedRoutes.some(
    (route) => req.method === route.method && route.urlPattern.test(req.url),
  );
  if (shouldExclude) {
    return next(req);
  }

  const preference = inject(PreferenceService);
  const dossierService = inject(DossierService);
  let headers = req.headers;
  if (preference.isClient && dossierService.dossierId) {
    const cabinetId = dossierService.cabinetId;
    if (cabinetId) {
      if (!headers.has('X-CABINET')) {
        headers = headers.append('X-CABINET', cabinetId.toString());
      }
    }
  }

  return next(
    req.clone({
      headers,
    }),
  );
};
